<h1 i18n="edit user|page title">Edit user</h1>

<form [formGroup]="form" class="mt-10 m-3" (ngSubmit)="onSubmit()">
  <div class="flex flex-row gap-10">
    <div class="flex flex-col gap-6 w-150">
      <div>
        <p-floatlabel>
          <p-select [options]="titleOptions" formControlName="title" [showClear]="true" fluid />
          <label i18n="user form|title label">Title</label>
        </p-floatlabel>
      </div>

      <div>
        <p-floatlabel>
          <input pInputText formControlName="firstname" fluid />
          <label i18n="user form|firstname label">Firstname</label>
        </p-floatlabel>
        @let firstnameControl = form.get('firstname');
        @if (firstnameControl?.invalid && firstnameControl?.dirty) {
          @if (firstnameControl?.hasError('required')) {
            <p-message i18n="user form|firstname required error" severity="error" variant="simple" size="small">
              Firstname is required.
            </p-message>
          }
          @if (firstnameControl?.hasError('minlength')) {
            <p-message i18n="user form|firstname minlength error" severity="error" variant="simple" size="small">
              Firstname must be at least 2 characters long.
            </p-message>
          }
          @if (firstnameControl?.hasError('withoutPattern')) {
            <p-message i18n="user form|firstname only numbers error" severity="error" variant="simple" size="small">
              Firstname must not consist of only numbers.
            </p-message>
          }
        }
      </div>

      <div>
        <p-floatlabel>
          <input pInputText formControlName="lastname" fluid />
          <label i18n="user form|lastname label">Lastname</label>
        </p-floatlabel>
        @let lastnameControl = form.get('lastname');
        @if (lastnameControl?.invalid && lastnameControl?.dirty) {
          @if (lastnameControl?.hasError('required')) {
            <p-message i18n="user form|lastname required error" severity="error" variant="simple" size="small">
              Lastname is required.
            </p-message>
          }
          @if (lastnameControl?.hasError('minlength')) {
            <p-message i18n="user form|lastname minlength error" severity="error" variant="simple" size="small">
              Lastname must be at least 2 characters long.
            </p-message>
          }
          @if (lastnameControl?.hasError('withoutPattern')) {
            <p-message i18n="user form|lastname only numbers error" severity="error" variant="simple" size="small">
              Lastname must not consist of only numbers.
            </p-message>
          }
        }
      </div>

      <div>
        <p-floatlabel>
          <input pInputText formControlName="company" fluid />
          <label i18n="user form|company label">Company</label>
        </p-floatlabel>
        @let companyControl = form.get('company');
        @if (companyControl?.invalid && companyControl?.dirty) {
          @if (companyControl?.hasError('required')) {
            <p-message i18n="user form|company required error" severity="error" variant="simple" size="small">
              Company is required.
            </p-message>
          }
          @if (companyControl?.hasError('minlength')) {
            <p-message i18n="user form|company minlength error" severity="error" variant="simple" size="small">
              Company must be at least 2 characters long.
            </p-message>
          }
          @if (companyControl?.hasError('withoutPattern')) {
            <p-message i18n="user form|company only numbers error" severity="error" variant="simple" size="small">
              Company must not consist of only numbers.
            </p-message>
          }
        }
      </div>

      <div>
        <p-floatlabel>
          <input pInputText formControlName="street" fluid />
          <label i18n="user form|street label">Street</label>
        </p-floatlabel>
        @let streetControl = form.get('street');
        @if (streetControl?.invalid && streetControl?.dirty) {
          @if (streetControl?.hasError('required')) {
            <p-message i18n="user form|street required error" severity="error" variant="simple" size="small">
              Street is required.
            </p-message>
          }
          @if (streetControl?.hasError('minlength')) {
            <p-message i18n="user form|street minlength error" severity="error" variant="simple" size="small">
              Street must be at least 2 characters long.
            </p-message>
          }
          @if (streetControl?.hasError('withoutPattern')) {
            <p-message i18n="user form|street only numbers error" severity="error" variant="simple" size="small">
              Street must not consist of only numbers.
            </p-message>
          }
        }
      </div>

      <div>
        <p-floatlabel>
          <input pInputText formControlName="zip" fluid />
          <label i18n="user form|zip label">Zip</label>
        </p-floatlabel>
        @let zipControl = form.get('zip');
        @if (zipControl?.invalid && zipControl?.dirty) {
          @if (zipControl?.hasError('required')) {
            <p-message i18n="user form|zip required error" severity="error" variant="simple" size="small">
              Zip is required.
            </p-message>
          }
          @if (zipControl?.hasError('minlength')) {
            <p-message i18n="user form|zip minlength error" severity="error" variant="simple" size="small">
              Zip must be at least 3 characters long.
            </p-message>
          }
          @if (zipControl?.hasError('maxlength')) {
            <p-message i18n="user form|zip maxlength error" severity="error" variant="simple" size="small">
              Zip must be at most 10 characters long.
            </p-message>
          }
        }
      </div>

      <div>
        <p-floatlabel>
          <input pInputText formControlName="city" fluid />
          <label i18n="user form|city label">City</label>
        </p-floatlabel>
        @let cityControl = form.get('city');
        @if (cityControl?.invalid && cityControl?.dirty) {
          @if (cityControl?.hasError('required')) {
            <p-message i18n="user form|city required error" severity="error" variant="simple" size="small">
              City is required.
            </p-message>
          }
          @if (cityControl?.hasError('minlength')) {
            <p-message i18n="user form|city minlength error" severity="error" variant="simple" size="small">
              City must be at least 3 characters long.
            </p-message>
          }
          @if (cityControl?.hasError('maxlength')) {
            <p-message i18n="user form|city maxlength error" severity="error" variant="simple" size="small">
              City must be at most 50 characters long.
            </p-message>
          }
        }
      </div>
      
      <div>
        <p-floatlabel>
          <app-country-selector formControlName="country" placeholder="" />
          <label i18n="user form|country label">Country</label>
        </p-floatlabel>
        @let countryControl = form.get('country');
        @if (countryControl?.invalid && countryControl?.dirty) {
          @if (countryControl?.hasError('required')) {
            <p-message i18n="user form|country required error" severity="error" variant="simple" size="small">
              Country is required.
            </p-message>
          }
          @for (remoteMessage of getRemoteValidationMessages(countryControl); track remoteMessage) {
            <p-message severity="error" variant="simple" size="small">
              {{ remoteMessage }}
            </p-message>
          }
        }
      </div>
      
      <div>
        <p-floatlabel>
          <app-country-state-selector
            formControlName="countryState"
            [country]="selectedCountry"
            placeholder="" />
          <label i18n="user form|country state label">Country State</label>
        </p-floatlabel>
        @let countryStateControl = form.get('countryState');
        @if (countryStateControl?.invalid && countryStateControl?.dirty) {
          @for (remoteMessage of getRemoteValidationMessages(countryStateControl); track remoteMessage) {
            <p-message severity="error" variant="simple" size="small">
              {{ remoteMessage }}
            </p-message>
          }
        }
      </div>
      
      <div>
        <p-floatlabel>
          <input pInputText formControlName="email" fluid />
          <label i18n="user form|email label">Email</label>
        </p-floatlabel>
        @let emailControl = form.get('email');
        @if (emailControl?.invalid && emailControl?.dirty) {
          @if (emailControl?.hasError('required')) {
            <p-message i18n="user form|email required error" severity="error" variant="simple" size="small">
              Email is required.
            </p-message>
          }
          @if (emailControl?.hasError('email')) {
            <p-message i18n="user form|email pattern error" severity="error" variant="simple" size="small">
              Email must be a valid email address.
            </p-message>
          }
          @for (remoteMessage of getRemoteValidationMessages(emailControl); track remoteMessage) {
            <p-message severity="error" variant="simple" size="small">
              {{ remoteMessage }}
            </p-message>
          }
        }
      </div>

      <div>
        <p-floatlabel>
          <input pInputText formControlName="phone" fluid />
          <label i18n="user form|phone label">Phone</label>
        </p-floatlabel>
        <p-message i18n="user form|phone hint" severity="secondary" variant="simple">
          Example +1.123456789
        </p-message>
        @let phoneControl = form.get('phone');
        @if (phoneControl?.invalid && phoneControl?.dirty) {
          @if (phoneControl?.hasError('required')) {
            <p-message i18n="user form|phone required error" severity="error" variant="simple" size="small">
              Phone is required.
            </p-message>
          }
          @if (phoneControl?.hasError('pattern')) {
            <p-message i18n="user form|phone pattern error" severity="error" variant="simple" size="small">
              Phone must be a valid phone number.
            </p-message>
          }
        }
      </div>

      <div>
        <p-floatlabel>
          <input pInputText formControlName="fax" fluid />
          <label i18n="user form|fax label">Fax</label>
        </p-floatlabel>
        @let faxControl = form.get('fax');
        @if (faxControl?.invalid && faxControl?.dirty) {
          @if (faxControl?.hasError('pattern')) {
            <p-message i18n="user form|fax pattern error" severity="error" variant="simple" size="small">
              Fax must be a valid fax number.
            </p-message>
          }
        }
      </div>

      <div>
        <p-floatlabel>
          <input pInputText formControlName="cellPhone" fluid />
          <label i18n="user form|cell phone label">Cell phone</label>
        </p-floatlabel>
        @let cellPhoneControl = form.get('cellPhone');
        @if (cellPhoneControl?.invalid && cellPhoneControl?.dirty) {
          @if (cellPhoneControl?.hasError('pattern')) {
            <p-message i18n="user form|cell phone pattern error" severity="error" variant="simple" size="small">
              Cell phone must be a valid cell phone number.
            </p-message>
          }
        }
      </div>
    </div>
    <div class="flex flex-col gap-6 w-150">
      <div>
        <p-floatlabel>
          <input pInputText formControlName="login" fluid />
          <label i18n="user form|username label">Username</label>
        </p-floatlabel>
        <p-message i18n="user form|login hint" severity="secondary" variant="simple">
          You use this name to sign into BrandShelter. Must be between 8 and 255 alphanumeric characters.
          May contain special characters: _-+.@. May not contain white space.
        </p-message>
        @let loginControl = form.get('login');
        @if (loginControl?.invalid && loginControl?.dirty) {
          @if (loginControl?.hasError('required')) {
            <p-message i18n="user form|login required error" severity="error" variant="simple" size="small">
              Username is required.
            </p-message>
          }
          @if (loginControl?.hasError('pattern')) {
            <p-message i18n="user form|login pattern error" severity="error" variant="simple" size="small">
              Username must be alphanumeric, special characters allowed: _-+@. (no white space).
            </p-message>
          }
          @for (remoteMessage of getRemoteValidationMessages(loginControl); track remoteMessage) {
            <p-message severity="error" variant="simple" size="small">
              {{ remoteMessage }}
            </p-message>
          }
        }
      </div>

      <div>
        <p-floatlabel>
          <app-language-select [control]="languageControl"></app-language-select>
          <label i18n="user form|language label">Language</label>
        </p-floatlabel>
        <p-message i18n="user form|language hint" severity="secondary" variant="simple">
          Choose a language for the user interface.
        </p-message>
        @if (languageControl.invalid && languageControl.dirty) {
          @if (languageControl.hasError('required')) {
            <p-message i18n="user form|language required error" severity="error" variant="simple" size="small">
              Language is required.
            </p-message>
          }
        }
      </div>

      <div>
        <p-floatlabel>
          <input pInputText formControlName="commercialRegisterNumber" fluid />
          <label i18n="user form|commercial register number label">Commercial Register Number</label>
        </p-floatlabel>
      </div>

      <div>
        <p-floatlabel>
          <input pInputText formControlName="idCardNumber" fluid />
          <label i18n="user form|id card number label">ID Card Number</label>
        </p-floatlabel>
      </div>

      <div>
        <p-floatlabel>
          <input pInputText formControlName="taxNumberCompany" fluid />
          <label i18n="user form|tax number company label">Tax Number Company</label>
        </p-floatlabel>
      </div>

      <div>
        <p-floatlabel>
          <input pInputText formControlName="allowedIpAddresses" fluid />
          <label i18n="user form|allowed ip addresses label">Allowed IP Addresses</label>
        </p-floatlabel>
        <p-message i18n="user form|allowed ip addresses hint" severity="secondary" variant="simple">
          Restricts access to BrandShelter to one or more IP addresses, comma-separated.
          It also accepts 'address/prefixlen' and 'address/mask' formats.
          An IPv6 address may be enclosed with '[' and ']'. Current IP: ::1
        </p-message>
        @let allowedIpAddressesControl = form.get('allowedIpAddresses');
        @if (allowedIpAddressesControl?.invalid && allowedIpAddressesControl?.dirty) {
          @for(remoteMessage of getRemoteValidationMessages(allowedIpAddressesControl); track remoteMessage) {
            <p-message severity="error" variant="simple" size="small">
              {{ remoteMessage }}
            </p-message>
          }
        }
      </div>
    </div>
  </div>
  <button class="mt-5" pButton type="submit" i18n="user form|update user button">
    Update User
  </button>
</form>
